module.exports = __webpack_public_path__ + "assets/ea3e3e4bb7148de928b153cae84668ea.png";